import React, { useState } from 'react';
import Style from './tab.less';
import classNames from 'classnames';
import i18n from '@i18next/i18n';

export enum TabType {
    Before = 'before',
    Adjusted = 'adjusted',
}

export interface TabProps {
    onTabChange: (tab: TabType) => void;
}

export const TabComponent: React.FC<TabProps> = ({ onTabChange }) => {
    const [activeTab, setActiveTab] = useState<string>('adjusted');

    const handleTabClick = (tab: TabType) => {
        setActiveTab(tab);
        onTabChange(tab);
    };

    return (
        <div className={Style['tab-container']}>
            <div
                className={classNames({
                    [Style.tab]: true,
                    [Style['tab-active']]: activeTab === TabType.Adjusted,
                })}
                onClick={() => handleTabClick(TabType.Adjusted)}
            >
                {i18n.t('调整后')}
            </div>
            <div
                className={classNames({
                    [Style.tab]: true,
                    [Style['tab-active']]: activeTab === TabType.Before,
                })}
                onClick={() => handleTabClick(TabType.Before)}
            >
                {i18n.t('调整前')}
            </div>
        </div>
    );
};
